import { render } from "./DocumentItem.vue?vue&type=template&id=28ccbdb9&scoped=true"
import script from "./DocumentItem.vue?vue&type=script&lang=js"
export * from "./DocumentItem.vue?vue&type=script&lang=js"

import "./DocumentItem.vue?vue&type=style&index=0&id=28ccbdb9&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ccbdb9"]])

export default __exports__